import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { MdOutlineMailOutline } from "react-icons/md";
import { RiLock2Line } from "react-icons/ri";
import { AiOutlineUser } from "react-icons/ai";
import { PiSignOut } from "react-icons/pi";

import Spinner from "../../../shared-components/Spinner/Spinner";
import { registerUser } from "../../../actions/userActions";
import { USER_REGISTER_RESET } from "../../../constants/userConstants";
import AuthLayout from "../shared/AuthLayout";
import AuthInput from "../shared/AuthInput";
import RoleToggle from "../shared/RoleToggle";

const SignUp = () => {
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    password: "",
    is_service_provider: false,
  });

  const { message, error, loading } = useSelector((state) => state.userRegister);
  const { user } = useSelector((state) => state.userLogin);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // USE EFFECT

  useEffect(() => {
    if (user) {
      navigate("/");
    }
    if (message) {
      navigate("/sign-in");
      toast.success(message);
    }

    if (error) {
      toast.error(error);
      dispatch({ type: USER_REGISTER_RESET });
    }
  }, [message, error, user]);

  //   Change Input Handler
  const changeInputHandler = (event) => {
    setFormData((prevState) => {
      return {
        ...prevState,
        [event.target.id]: event.target.value,
      };
    });
  };

  //   Form Submit Handler
  const submitFormHandler = (event) => {
    event.preventDefault();
    if (formData.email === "" || formData.password === "") {
      return toast.error("Please enter your email and choose a password");
    }
    if (formData.password.length <= 8) {
      return toast.error("Password must be at least 9 characters");
    }
    dispatch(registerUser(formData));
  };

  return loading ? (
    <Spinner />
  ) : (
    <AuthLayout
      title="Create your account"
      subtitle="Find and book secure storage near you in minutes."
      side={{
        heading: (
          <>
            Find the right space <span>in minutes.</span>
          </>
        ),
        points: [
          "Search by location, size, and storage type",
          "Compare real prices — no phone calls needed",
          "Book online and pay securely through Stripe",
        ],
      }}
    >
      <RoleToggle active="renter" />

      <div className="auth-card">
        <form onSubmit={submitFormHandler}>
          <div className="row gx-3">
            <div className="col-sm-6">
              <AuthInput
                label="First name"
                id="firstname"
                value={formData.firstname}
                onChange={changeInputHandler}
                icon={<AiOutlineUser size={20} />}
                placeholder="Jordan"
                autoComplete="given-name"
              />
            </div>
            <div className="col-sm-6">
              <AuthInput
                label="Last name"
                id="lastname"
                value={formData.lastname}
                onChange={changeInputHandler}
                icon={<AiOutlineUser size={20} />}
                placeholder="Smith"
                autoComplete="family-name"
              />
            </div>
          </div>
          <AuthInput
            label="Email address"
            id="email"
            type="email"
            value={formData.email}
            onChange={changeInputHandler}
            icon={<MdOutlineMailOutline size={20} />}
            placeholder="you@example.com"
            autoComplete="email"
          />
          <AuthInput
            label="Password"
            id="password"
            type="password"
            value={formData.password}
            onChange={changeInputHandler}
            icon={<RiLock2Line size={20} />}
            placeholder="Create a password"
            autoComplete="new-password"
            helper="At least 9 characters"
          />

          <button type="submit" className="a-font auth-submit mt-2">
            Create Account <PiSignOut size={18} />
          </button>
        </form>
      </div>

      <Link to="/sign-in" className="a-font auth-footer-link">
        Already have an account? <span>Sign in</span>
      </Link>
    </AuthLayout>
  );
};

export default SignUp;
